import Moment from 'moment'

import RatingStars from '../../../components/ReusableComponents/RatingStars'
import { calculateRunningAverage } from '../calculateRunningAverage'
import { ReactComponent as StarIcon } from '../ReviewRow/star.svg'
import styles from './Sidebar.module.scss'

const Sidebar = ({ data, dailySummaries }) => {
  const { average, reviewCount } = calculateRunningAverage(dailySummaries)

  return (
    <div className={styles.sidebar}>
      {data.length > 0 && (
        <div className={styles.container}>
          <h2>Recent reviews</h2>
          {data.map(review => (
            <Review {...review} key={review.reviewId} />
          ))}
        </div>
      )}
      <div
        className={[
          styles.runningAverage,
          data.length > 0 ? styles.runningAverageWithRecentReviews : ''
        ].join(' ')}
      >
        <h2>Running average</h2>
        <p className={styles.runningAverageValue}>
          {average.toFixed(1)} <StarIcon />
        </p>
        <p className={styles.runningAverageMeta}>
          {reviewCount > 0
            ? `Based on ${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}`
            : 'No reviews in selected period'}
        </p>
      </div>
    </div>
  )
}

const Review = ({ rating, customerName, reviewedOn, roomNumber }) => (
  <div className={styles.rating}>
    <p className={styles.guestName}>
      <span>{customerName}</span>
      <RatingStars rating={rating} />
    </p>
    <p className={styles.moreInfo}>
      <span className={styles.date}>{Moment(reviewedOn).format('MMM DD')}</span>
      {roomNumber && (
        <>
          <span className={styles.seperator}>•</span>
          <span className={styles.date}>Room {roomNumber}</span>
        </>
      )}
    </p>
  </div>
)

export default Sidebar
